import EmailComposeContainer from "../../Componant/Email/EmailCompose";

const EmailCompose = () => {
  return (
    <div className="page-body">
      <EmailComposeContainer />
    </div>
  );
};

export default EmailCompose;
